module.exports = __webpack_public_path__ + "static/media/a15_lighting.23439d89.png";